<template>
    <Icon
        v-if="icon"
        class="base-icon"
        :name="iconKey"
        :customize="customize"
    />
</template>

<script setup lang="ts">
const props = defineProps({
    icon: {
        type: String,
        required: true
    }
});

const iconKey = computed(() => {
    // temp: use a different icon for this key, weird caching issue in production
    // remove this when the issue is resolved
    if (props.icon === 'spa') {
        return 'local:wellness';
    }

    return `local:${props.icon}`;
});

// Define the customize function to modify SVG content
const customize = (
    content: string,
    prefix: string
) => {
    // If content is wrapped with `<g fill="#000000" />` do nothing, otherwise, add it:
    if (!content.includes('<g fill="#000000"')) {
        content = `<g fill="#000000">${content}</g>`;
    }

    return content
        .replace(/fill="(?!none)[^"]*"/g, 'fill="currentColor"')
        .replace(/stroke="(?!none)[^"]*"/g, 'stroke="currentColor"');
};
</script>
